import React, { useState, useEffect, useContext } from "react";
import {
  Input,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import NoImage from "../images/no-image.png";
import { BsPlusSquare } from "react-icons/bs";
import { ApiCallGateway } from "../Network/apiCallGateway";
import { sweetAlert } from "../Utils/SweetAlert";

function ChoseMembers(props) {
  const userData = JSON.parse(localStorage.getItem("loggedInUser"));

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [userList, setUserList] = useState([]);
  const [searchString, setSearchString] = useState("");
  const toggleDropdown = () =>
    setDropdownOpen((prevState) => !prevState);
  useEffect(() => {
    fetchUsers(searchString);
  }, [searchString]);

  async function fetchUsers(searchString) {
    const users = await ApiCallGateway.user.allUsers(searchString);
    // console.log(users);
    setUserList(users?.data || []);
  }
  async function fetchUsersByEmail(searchString) {
    const users = await ApiCallGateway.user.allUsersByEmails(
      searchString
    );
    setSearchString("");
    // add for loop here
    for (let i = 0; i < users?.data?.length; i++) {
      if (userData?._id != users?.data[i]?._id) {
        props?.onSelect(users?.data[i]);
      }
    }
  }
  const websiteDomain = "indusnet.co.in";
  function hasSameDomain(email, websiteDomain) {
    const emailDomain = email.split("@")[1].toLowerCase();
    return websiteDomain.toLowerCase() === emailDomain;
  }
  return (
    <div className="choseMember">
      <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
        <DropdownToggle caret>
          <div className="formElmWrap">
            <Input
              id="search_string"
              name="search String"
              placeholder="Choose Member"
              autoComplete="off"
              type="text"
              value={searchString}
              onChange={(e) => setSearchString(e.target.value)}
            />
            <span className="formIcon plus">{<BsPlusSquare />}</span>
          </div>
        </DropdownToggle>
        <DropdownMenu>
          {userList?.data?.length < 1 ? (
            <DropdownItem
              key={"user new"}
              onClick={() => {
                if (
                  searchString.includes(" ") ||
                  searchString.includes(",")
                ) {
                  fetchUsersByEmail(searchString);
                } else {
                  if (hasSameDomain(searchString, websiteDomain)) {
                    props?.onSelect({
                      email: searchString,
                      name: searchString.split("@")[0].toLowerCase(),
                    });
                  } else {
                    sweetAlert(
                      "Oops!",
                      "You can share with all individuals within Indus Net Technologies."
                    );
                  }
                }
              }}
            >
              <img
                className="memberIcon "
                src={NoImage}
                alt="user"
                referrerPolicy="no-referrer"
              />
              {searchString}
            </DropdownItem>
          ) : null}

          {userList?.data?.map((item, index) => {
            return (
              <DropdownItem
                key={"user" + index}
                onClick={() => {
                  if (props?.userSkip) {
                    props?.onSelect(item);
                  } else if (userData?._id != item?._id) {
                    props?.onSelect(item);
                  }
                }}
              >
                <img
                  className="memberIcon "
                  src={item?.profilePhoto || NoImage}
                  alt="user"
                  referrerPolicy="no-referrer"
                />
                {item?.name}
              </DropdownItem>
            );
          })}
        </DropdownMenu>
      </Dropdown>
    </div>
  );
}

export default ChoseMembers;
